/**
 * Catalog Instance Detection and Management
 * PHASE 2: Database-Driven Catalog Detection - Production Implementation
 * REFACTORED: Now imports from modular structure for maintainability
 */

// Re-export from modular structure for backward compatibility
export type { CatalogInstance } from './catalog/types';
export {
  detectCatalogInstance,
  clearUserCatalogCache,
  getUserActiveCatalogId,
  getCatalogBranding
} from './catalog';

// Legacy function exports for backward compatibility
export {
  getCatalogInstanceId,
  getCatalogContext,
  isPartnerCatalog,
  getCatalogDisplayName
} from '../hooks/useCatalog';